function ButtonConfig() {
    const siteButtons = document.querySelectorAll('.button')
    const siteButtonsNew = document.querySelectorAll('.button-new')
    const featuredProjectsButtons = document.querySelectorAll('.project-card__client-name')

    if (siteButtons) {
        siteButtons.forEach(button => {
            let buttonText = button.childNodes[0]
            let hoverText = buttonText.dataset.changetext
            let prevText = buttonText.textContent
        
            if (hoverText) {
                button.addEventListener('mouseenter', function() {   
                    buttonText.textContent = hoverText
                })
        
                button.addEventListener('mouseleave', function() {   
                    buttonText.textContent = prevText
                })
            }
        })
    }

    if (siteButtonsNew) {
        siteButtonsNew.forEach(button => {
            let buttonText = button
            let hoverText = buttonText.dataset.changetext
            let prevText = buttonText.textContent
        
            if (hoverText) {
                button.addEventListener('mouseenter', function() {   
                    buttonText.textContent = hoverText
                })
        
                button.addEventListener('mouseleave', function() {   
                    buttonText.textContent = prevText
                })
            }
        })
    }
    
    if (featuredProjectsButtons) {
        featuredProjectsButtons.forEach(button => {
            let buttonText = button
            let hoverText = buttonText.dataset.changetext
            let prevText = buttonText.textContent
        
            if (hoverText) {
                button.addEventListener('mouseenter', function() {   
                    buttonText.textContent = hoverText
                })
        
                button.addEventListener('mouseleave', function() {   
                    buttonText.textContent = prevText
                })
            }
        })
    }
}

export default ButtonConfig